import { render, staticRenderFns } from "./system-point.vue?vue&type=template&id=a2959982&"
import script from "./system-point.vue?vue&type=script&lang=js&"
export * from "./system-point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports